import { defineComponent as _defineComponent } from 'vue'
interface ISocialMedia {
  name: string
  icon: string
  link: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  props: {
  logoUrl: {
    required: false,
    type: String,
    default: "/afg_logo_01.svg",
  },
},
  setup(__props) {



const socialMedia: ISocialMedia[] = [
  {
    name: "Linkedin",
    icon: "la-linkedin",
    link: "https://www.linkedin.com/company/africa-foresight-group",
  },
  {
    name: "Twitter",
    icon: "la-twitter",
    link: "https://twitter.com/AfricaForesight",
  },
  {
    name: "Instagram",
    icon: "la-instagram",
    link: "https://www.instagram.com/africaforesightgroup/",
  },
]

return { __sfc: true,socialMedia }
}

})